<template>
  <div id="prov-pdf-view">
    <div class="page page1">
      <div class="title">VEHICLE INFORMATION:</div>
      <div class="d-flex f-margin">
        <div class="left">
          <img :src="vehicleInfo.img" v-if="vehicleInfo.img" class="img2" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">MANUFACTURER</div>
              <div class="value">{{ vehicleInfo.manufacturer }}</div>
            </div>
            <div class="field">
              <div class="label">MODEL</div>
              <div class="value">{{ vehicleInfo.model }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">YEAR</div>
              <div class="value">{{ vehicleInfo.year }}</div>
            </div>
            <div class="field">
              <div class="label">VEHICLE TYPE</div>
              <div class="value">{{ vehicleInfo.type || '--' }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">LICENSE PLATE</div>
              <div class="value">{{ vehicleInfo.licensePlate }}</div>
            </div>
            <div class="field">
              <div class="label">VEHICLE IDENTIFICATION NUMBER</div>
              <div class="value">{{ vehicleInfo.identificationNumber }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">DOOR</div>
              <div class="value">{{ vehicleInfo.door }}</div>
            </div>
            <div class="field">
              <div class="label">CAPACITY</div>
              <div class="value">{{ vehicleInfo.capacity }}</div>
            </div>
          </div>
          <div class="">
            <input type="checkbox" :checked="vehicleInfo.wheelchair" />
            Equipped with wheelchair lift.
          </div>
          <div class="f-margin">
            <input type="checkbox" :checked="vehicleInfo.serviceDog" />
            Can accommodate a service dog.
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="left">
          <img :src="documentation.vehicleRegistrationImg" v-if="documentation.vehicleRegistrationImg" class="img3" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="out-label">VEHICLE REGISTRATION</div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.vehicleRegistrationExp || '--' }}</div>
          </div>
        </div>
      </div>

      <div class="title">
        ACCOUNT TYPE:
        <b>{{ accountType.type }}</b>
      </div>

      <div class="title">BUSINESS INFORMATION:</div>
      <div class="d-flex f-margin">
        <div class="left">
          <div v-if="businessInfo.type === 'Sole Proprietorship'">
            <div class="img-label">SSN image</div>
            <img :src="businessInfo.ssnImg" v-if="businessInfo.ssnImg" class="img4" />
            <img :src="noPhotoUrl" v-else />
          </div>
          <div v-else>
            <div class="img-label">EIN image</div>
            <img :src="businessInfo.einImg" v-if="businessInfo.einImg" class="img4" />
            <img :src="noPhotoUrl" v-else />

            <div class="img-label" style="margin-top:20px">W-9 FORM</div>
            <img :src="businessInfo.w9fileImg" v-if="businessInfo.w9fileImg" class="img4" />
            <img :src="noPhotoUrl" v-else />
          </div>
        </div>
        <div class="right">
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">BUSINESS NAME</div>
              <div class="value">{{ businessInfo.name }}</div>
            </div>
            <div class="field">
              <div class="label">TYPE OF BUSINESS</div>
              <div class="value">{{ businessInfo.type }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field" v-if="businessInfo.type === 'Sole Proprietorship'">
              <div class="label">SOCIAL SECURITY NUMBER (SSN)</div>
              <div class="value">{{ businessInfo.ssn || '--' }}</div>
            </div>
            <div class="field">
              <div class="label">EMPLOYER ID NUMBER (EIN)</div>
              <div class="value">{{ businessInfo.ein || '--' }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">ADDRESS</div>
              <div class="value">{{ businessInfo.address1 || '--' }}</div>
            </div>
            <div class="field">
              <div class="label">ADDRESS 2</div>
              <div class="value">{{ businessInfo.address2 || '--' }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field">
              <div class="label">CITY</div>
              <div class="value">{{ businessInfo.city }}</div>
            </div>
            <div class="field">
              <div class="label">COUNTRY</div>
              <div class="value">{{ businessInfo.country }}</div>
            </div>
          </div>
          <div class="d-flex f-margin">
            <div class="field" v-show="businessInfo.country === 'United States'">
              <div class="label">STATE</div>
              <div class="value">{{ businessInfo.state }}</div>
            </div>
            <div class="field">
              <div class="label">ZIP</div>
              <div class="value">{{ businessInfo.zip }}</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
    <div class="page page2">
      <div class="d-flex" v-if="businessInfo.type === 'Sole Proprietorship'">
        <div class="left">
          <div class="img-label">EIN image</div>
          <img :src="businessInfo.einImg" v-if="businessInfo.einImg" class="img4" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right text-center">
          <div class="img-label">W-9 FORM</div>
          <img :src="businessInfo.w9fileImg" v-if="businessInfo.w9fileImg" class="img4" />
          <img :src="noPhotoUrl" v-else />
        </div>
      </div>

      <div class="title">DOCUMENTATION</div>
      <div class="d-flex f-margin">
        <div class="left">
          <img :src="documentation.insuranceImg" v-if="documentation.insuranceImg" class="img5" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">INSURANCE COMPANY NAME</div>
            <div class="value">{{ documentation.insuranceCompany || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">INSURANCE POLICY #</div>
            <div class="value">{{ documentation.insurancePolicy || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.insuranceExp || '--' }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex f-margin">
        <div class="left">
          <img :src="documentation.cityLicenseImg" v-if="documentation.cityLicenseImg" class="img6" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">CITY LICENSE #</div>
            <div class="value">{{ documentation.cityLicense || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.cityLicenseExp || '--' }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex f-margin" v-if="accountType.type === 'tcp'">
        <div class="left">
          <img :src="documentation.tcpPermitImg" v-if="documentation.tcpPermitImg" class="img6" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">TCP PERMIT #</div>
            <div class="value">{{ documentation.tcpPermit || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.tcpPermitExp || '--' }}</div>
          </div>
        </div>
      </div>
      <div class="d-flex f-margin" v-if="accountType.type === 'tcp'">
        <div class="left">
          <img :src="documentation.airportPermitImg" v-if="documentation.airportPermitImg" class="img6" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">AIRPORT PERMIT #</div>
            <div class="value">{{ documentation.airportPermit || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.airportPermitExp || '--' }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="d-flex f-margin">
        <div class="left">
          <img :src="documentation.driversLicenseImg" v-if="documentation.driversLicenseImg" class="img7" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">DRIVER'S LICENSE #</div>
            <div class="value">{{ documentation.driversLicense || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.driversLicenseExp || '--' }}</div>
          </div>
        </div>
      </div> -->

      <div class="d-flex f-margin">
        <div class="left">
          <img :src="documentation.vehicleInspectionImg" v-if="documentation.vehicleInspectionImg" class="img8" />
          <img :src="noPhotoUrl" v-else />
        </div>
        <div class="right">
          <div class="field f-margin">
            <div class="label">VEHICLE SAFETY INSPECTION PERFORMED BY</div>
            <div class="value">{{ documentation.vehicleInspection || '--' }}</div>
          </div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.vehicleInspectionExp || '--' }}</div>
          </div>
        </div>
      </div> 
    </div>

    <div class="page page3">
      <!-- <div class="d-flex f-margin">
        <div class="left">
          <img :src="documentation.drivingRecordImg" v-if="documentation.drivingRecordImg" class="img9" />
          <img :src="noPhotoUrl" v-else class="img10" />
        </div>
        <div class="right">
          <div class="out-label">DRIVER'S BACKGROUND CHECK</div>
          <div class="field f-margin">
            <div class="label">EXP. DATE</div>
            <div class="value">{{ documentation.drivingRecordExp || '--' }}</div>
          </div>
        </div>
      </div> -->

      <div class="title">ELIGIBILITY:</div>
      <div class="field">
        <p>HAVE YOU BEEN CONVICTED, WITHIN THE PAST 7 YEARS, OF DRIVING UNDER THE INFLUENCE OF DRUGS OR ALCOHOL, FRAUD, SEXUAL OFFENSES, USE OF A MOTOR VEHICLE TO COMMIT A FELONY, A CRIME INVOLVING PROPERTY DAMAGE AND/OR THEFT, ACTS OF VIOLENCE, OR ACTS OF TERROR?</p>
        <b>{{ eligibility.convicted ? 'YES' : 'NO' }}</b>
        
        <p>HAVE YOU EVER HAD A CONVICTION FOR RECKLESS DRIVING, DRIVING UNDER THE INFLUENCE, HIT AND RUN, OR DRIVING WITH A SUSPENDED OR REVOKED LICENSE?</p>
        <b>{{ eligibility.conviction ? 'YES' : 'NO' }}</b>
        
        <p>DO YOU PERSONALLY OWN THIS VEHICLE?</p>
        <b>{{ eligibility.ownVehicle ? 'YES' : 'NO' }}</b>
        
        <p>HAS THIS VEHICLE EVER BEEN SIGNIFICANTLY MODIFIED FROM FACTORY SPECIFICATIONS (E.G. "STRETCH VEHICLE", MADE NOT STREET LEGAL, ETC.)?</p>
        <b>{{ eligibility.modifiedVehicle ? 'YES' : 'NO' }}</b>
        
        <p>HAVE YOU HAD YOUR DRIVER'S LICENSE FOR AT LEAST 2 YEARS?</p>
        <b>{{ eligibility.driversLicense ? 'YES' : 'NO' }}</b>
      </div>

      <div class="title">AGREEMENTS:</div>
      <div class="field">
        <div class="f-margin a">
          <input type="checkbox" checked />
          I declare under penalty of perjury under the laws of the State of California that I am the driver listed on this application all of the information provided herein is true and correct.
        </div>
        <div class="f-margin a">
          <input type="checkbox" checked />
          <span v-html="$t('provider.agreements.agree', aggreementsLink)"></span>
        </div>
      </div>
      <div class="field">
        <div class="label">SIGNATURE</div>
        <div class="value signature">{{ signature }}</div>
        <div class="df-created">{{ created }}</div>
      </div>
    </div>
<!-- 
    <div class="page page4">
      
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import ApiProvider from '@/modules/api/provider/user-info'

export default {
  name: 'download-profile',
  data () {
    return {
      noPhotoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png',
      created: ''
    }
  },
  computed: {
    id () { return this.$route.params.id },
    provider () { return this.$store.state.provider },
    isActive () { return this.provider.active },
    basicInfo () { return this.provider.basicInfo },
    vehicleInfo () { return this.provider.vehicleInfo },
    accountType () { return this.provider.accountType },
    businessInfo () { return this.provider.businessInfo },
    documentation () { return this.provider.documentation },
    eligibility () { return this.provider.eligibility },
    signature () { return this.provider.signature },
    driverId: {
      get () { return this.$store.state.provider.driverId },
      set (x) { this.$store.commit('provider/setDriverId', x) }
    },
    aggreementsLink () {
      if (this.getVariable('brand') === 'op') {
        return {
          conductRules: '<a href="https://opoli.com/driver/conduct-rules/" target="_blank">https://opoli.com/driver/conduct-rules/</a>',
          terms: '<a href="https://opoli.com/terms" target="_blank">https://opoli.com/terms</a>',
          privacy: '<a href="https://opoli.com/privacy" target="_blank">https://opoli.com/privacy</a>',
        }
      }
      return {
        conductRules: '<a href="https://www.primetimerideshare.com/driver-conduct-rules" target="_blank">https://www.primetimerideshare.com/driver-conduct-rules</a>',
        terms: '<a href="https://www.primetimerideshare.com/terms" target="_blank">https://www.primetimerideshare.com/terms</a>',
        privacy: '<a href="https://www.primetimerideshare.com/privacy-policy" target="_blank">https://www.primetimerideshare.com/privacy-policy</a>',
      }
    },
    _created () { return this.$store.state.provider.created }
  },
  methods: {
    init () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: ''})

      ApiProvider.getProviderData(self, self.id, function (res) {
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$router.push({name: 'MissingPage'})
          return
        }
        document.title = `${self.basicInfo.firstName} ${self.basicInfo.lastName}`;

        if (!res.driverNum) {
          self.getNextDriverNum()
          return
        }
        // if (self.getVariable('brand') === 'op') self.created = self._created
        self.created = self._created
        if (self.getVariable('brand') === 'ptrs') {
          if (self.isBefore2026(self._created)) self.created = '01/01/2026'
        }
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
      })
    },
    getNextDriverNum () {
      let self = this
      self.$sdk.get('/provider/nextNum', {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (!res.error) {
          self.driverId = res.next
          self.nextDriverId = res.next
          return
        }
      })
    },
    getVariable (url) {
      let query = window.location.search.substring(1);
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === url) {
          return pair[1]
        }
      }
      return false
    },
    isBefore2026 (x) {
      let year = moment(x, 'MM/DD/YYYY').format('YYYY')
      year = parseInt(year)
      return year < 2026
    }
  },
  watch: {
    provId: function () {
      this.init()
    },
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">
@page  {
  margin: 0;
  size: A4;
}
body{ background: #fff; }
#side-menu, .phone-app{ display: none; }
#prov-pdf-view{
  position: absolute;
  top: 0;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;

  .page{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .d-name{
    font-size: 28px;
    font-weight: 600;
  }
  .vehicle-no{
    span{
      color: #999;
      font-weight: 600;
    }
  }
  .top-box{
    border: 1px solid #ccc;
    background: #fafafa;
    border-radius: 4px;
    padding: 10px;
    margin: 10px 0 20px;
    .left{
      text-align: left;
    }
  }
  .title{
    font-weight: 600;
    font-size: 21px;
    margin: 50px 0 20px;
    color: #09539f;

    &:first-child, &.no-tm{
      margin-top: 0;
    }
    b{
      color: #333;
      margin-left: 10px;
      text-transform: uppercase;
    }
  }
  .left{
    width: 40%;
    text-align: center;
  }
  .img-label{
    display: block;
    margin: 0 0 5px;
    font-weight: 600;
    color: #333;

    &:first-child{
      margin-top: 0;
    }
  }
  .right{
    width: 60%;
    padding-left: 20px;
  }
  .f-margin{
    margin-bottom: 20px;
  }
  .field{
    width: 100%;
    line-height: 1;

    .label{
      font-weight: 600;
      font-size: 12px;
      color: #757575;
      margin-bottom: 3px;
      text-transform: uppercase;
    }
    .value{
      &.signature{
        padding: 10px;
        border: 1px solid #ccc;
        background: #eee;
        color: #777;
        border-radius: 4px;
        line-height: 1;
      }
    }
    p{
      line-height: 1.3;
      color: #777;
      margin: 30px 0 5px;
      font-size: 14px;
      &:first-child{
        margin-top: 0;
      }
    }
    b{
      font-size: 18px;
      letter-spacing: .5px;
    }
  }
  .out-label{
    color: #333;
    font-weight: 600;
    font-size: 18x;
    letter-spacing: .5px;
    margin-bottom: 10px;
    display: block;
    border-bottom: 1px solid #ddd;
  }
  input{
    width: auto;
    display: inline-block;
    margin: 0 5px 10px 0;
  }
  .a{
    line-height: 1.4;

    input{
      margin-bottom: 0;
    }
  }

  img{
    max-height: 180px;
  }
  .img1{
    max-height: 230px;
  }
  .img10{
    max-height: 200px;
  }
}

.df-created{
  text-align: center;
  letter-spacing: .6px;
  font-size: 14px;
  color: #777;
  line-height: 1;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/DownloadProfile.vue